import bride from '~/images/brud.webp';
import clothes from '~/images/clothes.webp';
import djerf from '~/images/djerf.webp';
import ai from '~/images/inga.webp';
import penthouse from '~/images/penthouse.webp';
import pink from '~/images/pink.webp';
import cabinet from '~/images/skap.webp';
import nintendo from '~/images/switch.webp';
import toast from '~/images/toast.webp';
import outside from '~/images/ute.webp';
import type { CSSProperties } from 'react';

type Text = {
    fontSize: string;
    content: string;
};

type Image = {
    src: string;
    height?: string;
};

type Article = {
    width?: string;
    image: Image;
    prefix?: string;
    text: Text[];
};

const topArticles: Article[] = [
    {
        image: { src: djerf, height: '86.629526462396%' },
        width: 'article-width-half',
        text: [
            { content: 'Dette er', fontSize: '5.438em' },
            { content: 'Djerf-looken', fontSize: '3.375em' },
        ],
    },

    {
        image: { src: toast, height: '69.359331476323%' },
        prefix: 'Digg toast:',
        text: [
            { content: 'Med karamellisert', fontSize: '2.375em' },
            { content: 'løk og talleggio', fontSize: '2.875em' },
        ],
    },
];

const bottomArticles: Article[] = [
    {
        image: { src: ai, height: '114.43661971831%' },
        width: 'article-width-two-fifth',
        text: [
            { content: 'Boken rives', fontSize: '2.813em' },
            { content: 'vekk', fontSize: '6.875em' },
        ],
    },
    {
        image: { src: penthouse, height: '58.52534562212%' },
        width: 'article-width-three-fifth',
        prefix: '«Succession»-leilighet:',
        text: [
            { content: 'Prislapp:', fontSize: '5.938em' },
            { content: '306 mill.', fontSize: '5.938em' },
        ],
    },
    {
        image: { src: pink, height: '72.701949860724%' },
        width: 'article-width-half',
        text: [
            { content: 'Sjekk det', fontSize: '4.688em' },
            { content: 'unike hjemmet', fontSize: '2.875em' },
        ],
    },
    {
        image: { src: nintendo },
        prefix: 'Switch:',
        text: [
            { content: 'Kan sette', fontSize: '4.7em' },
            { content: 'rekord', fontSize: '6.2em' },
        ],
    },
];

const rightArticles: Article[] = [
    {
        image: { src: cabinet },
        prefix: 'Ekspertene tipser:',
        text: [{ content: 'Slik får du orden på kjøkkenet', fontSize: '' }],
    },
    {
        image: { src: bride },
        prefix: 'Brudekjole-trend:',
        text: [{ content: '- Markerer en ny fase', fontSize: '' }],
    },
    {
        image: { src: clothes },
        text: [{ content: 'Disse klærne eksisterer ikke', fontSize: '' }],
    },
    {
        image: { src: outside },
        prefix: 'Eksperttips:',
        text: [{ content: 'Slik får du mest ut av balkongen', fontSize: '' }],
    },
];

type Props = {
    width?: string;
    image: Image;
    prefix?: string;
    text: Text[];
};

export function Vg({ image, prefix, text, width = 'article-width-half' }: Props) {
    return (
        <article className={`article article-extract ${width} newsroom-vg skin-default has-article-image has-full-width-image`}>
            <div className="article-container">
                <figure>
                    <div style={{ paddingBottom: image.height }}>
                        <img alt="" className="article-image" loading="lazy" width="359" height="249" src={image.src} />
                    </div>
                </figure>
                <div className="titles">
                    {prefix && (
                        <span className="insert-title " role="presentation" aria-hidden="true">
                            {prefix}
                        </span>
                    )}
                    <h2
                        className="headline"
                        /* style={{ fontSize: "1.75rem" }} */
                        aria-label="Digg toast: Med karamellisert
          løk og talleggio">
                        {text.map((t, index) => (
                            <span key={index} aria-hidden="true" className="d-block " style={{ fontSize: t.fontSize }}>
                                {t.content}
                            </span>
                        ))}
                    </h2>
                </div>
            </div>
        </article>
    );
}
export function VgHard(props: Props) {
    return (
        <article className="article article-extract article-width-half newsroom-vg skin-default has-article-image has-full-width-image">
            <div className="article-container">
                <figure>
                    <div style={{ paddingBottom: '69.359331476323%' }}>
                        <img
                            alt=""
                            className="article-image"
                            sizes="(min-width: 734px) 359px, 48.9vw"
                            loading="lazy"
                            width="359"
                            height="249"
                            style={{ objectPosition: '50% 47%' }}
                            src={toast}
                        />
                    </div>
                </figure>
                <div className="titles">
                    <span className="insert-title " role="presentation" aria-hidden="true">
                        Digg toast:
                    </span>
                    <h2
                        className="headline"
                        style={{ fontSize: '1.75rem' }}
                        aria-label="Digg toast: Med karamellisert
          løk og talleggio">
                        <span aria-hidden="true" className="d-block " style={{ fontSize: '2.375rem' }}>
                            Med karamellisert{' '}
                        </span>
                        <span aria-hidden="true" className="d-block " style={{ fontSize: '2.875rem' }}>
                            løk og talleggio
                        </span>
                    </h2>
                </div>
            </div>
        </article>
    );
}

export function VgRight({ image, prefix, text }: Props) {
    return (
        <article className="article article-extract article-width-full article-full-size-first hoyrelopet newsroom-minmote skin-default has-article-image has-full-width-image lazy-render-auto">
            <div className="article-container">
                <figure>
                    <div style={{ paddingBottom: '100%' }}>
                        <img
                            src={image.src}
                            alt=""
                            className="article-image"
                            width="228"
                            height="228"
                            style={{ objectPosition: '51% 15%' }}
                        />
                    </div>
                </figure>
                <div className="titles fluid">
                    {prefix && (
                        <span className="insert-title " role="presentation" aria-hidden="true">
                            {prefix}
                        </span>
                    )}
                    {text.map((t, index) => (
                        <h2 key={index} className="headline">
                            {t.content}
                        </h2>
                    ))}
                </div>
            </div>
        </article>
    );
}

type VgAppProps = {
    children?: React.ReactNode;
    className?: string;
};

export function VgApp({ children, className }: VgAppProps) {
    return (
        <div className={`vgbody ${className}`}>
            {/* <Topbar /> */}
            <div className="app">
                <div className="front-container">
                    <main className="main-column" id="hovedlopet" style={{ '--front-main-column-width': '734px' } as CSSPropertiesWithVars}>
                        <div className="articles" style={{ marginBottom: 'var(--container-margin-bottom, 1rem)' }}>
                            {topArticles.map((article, index) => (
                                <Vg key={index} {...article} />
                            ))}
                            <div className="advert-wrap advert-device-desktop">{children}</div>
                            {bottomArticles.map((article, index) => (
                                <Vg key={index} {...article} />
                            ))}
                        </div>
                    </main>
                    <aside id="hoyrelopet">
                        <div className="articles" style={{ marginBottom: 'var(--container-margin-bottom, 1rem)' }}>
                            {rightArticles.map((article, index) => (
                                <VgRight key={index} {...article} />
                            ))}
                        </div>
                    </aside>
                </div>
            </div>
        </div>
    );
}

export interface CSSPropertiesWithVars extends CSSProperties {
    '--front-main-column-width': string;
}

export function StickyTopbar() {
    return (
        <div className="vg-nav-sticky">
            <div className="vg-nav-inner-sticky">
                <Logo />
                <div className="shortcuts">
                    <span className="nav-JaE7z nav-eJCP4">VG Live</span>
                    <span className="nav-JaE7z nav-eJCP4">VGTV</span>
                    <span className="nav-JaE7z nav-eJCP4">VG+</span>
                    <span className="nav-JaE7z nav-eJCP4">Sport</span>
                    <span className="nav-JaE7z nav-eJCP4">TV-guide</span>
                    <span className="nav-JaE7z nav-eJCP4">Tips oss</span>
                </div>
                <div className="vg-nav-end">
                    <Menu />
                </div>
            </div>
        </div>
    );
}

export function Topbar() {
    return (
        <div className="vg-nav">
            <div className="vg-nav-inner">
                <Logo />
                <div className="shortcuts">
                    <span className="nav-JaE7z nav-eJCP4">VG Live</span>
                    <span className="nav-JaE7z nav-eJCP4">VGTV</span>
                    <span className="nav-JaE7z nav-eJCP4">VG+</span>
                    <span className="nav-JaE7z nav-eJCP4">Sport</span>
                    <span className="nav-JaE7z nav-eJCP4">TV-guide</span>
                    <span className="nav-JaE7z nav-eJCP4">Tips oss</span>
                </div>
                <div className="vg-nav-end">
                    <Menu />
                </div>
            </div>
        </div>
    );
}

export function Logo() {
    return (
        <svg
            width="80"
            height="16"
            viewBox="0 0 80 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            className="vg-logo">
            <path d="M80 13.333A2.667 2.667 0 0 1 77.333 16H46.667A2.667 2.667 0 0 1 44 13.333V2.667A2.667 2.667 0 0 1 46.667 0h30.666A2.667 2.667 0 0 1 80 2.667V4H68.8v-.534a1.6 1.6 0 0 0-1.6-1.6H56.8a1.6 1.6 0 0 0-1.6 1.6v9.067a1.6 1.6 0 0 0 1.6 1.6h10.4a1.6 1.6 0 0 0 1.6-1.6V9.067H62V7.2h18v6.133ZM13.813 16 0 0h13.281l7.969 9.6L29.219 0H42.5L28.687 16H13.813Z"></path>
        </svg>
    );
}
export function Menu() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M2 5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 18a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z"></path>
        </svg>
    );
}
